import { render, staticRenderFns } from "./ProjectsOverviewField.vue?vue&type=template&id=756e91f5&scoped=true"
import script from "./ProjectsOverviewField.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectsOverviewField.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProjectsOverviewField.vue?vue&type=style&index=0&id=756e91f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756e91f5",
  null
  
)

export default component.exports